/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileLarge } from "./_background/background-file-large.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FilePackageLarge = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--large",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "large" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 160,
      height: 160,
      className: cls,
      "data-testid": "FilePackageLarge",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileLarge, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.505 24.11v11.126h1.997v16.268h8.985v-3h-5.985V35.24h20.996v13.265h-6.012v3h9.012V35.236h1.998V24.11H22.505Zm27.765 8.129v-.003h.226V27.11H25.505v5.126h.505v.003h24.26Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "m43.77 43.962-5.787-5.675-5.753 5.678 2.107 2.135 2.15-2.122v7.524h3v-7.538l2.183 2.14 2.1-2.142Z",
        fill: "var(--dig-color__fileicon__icon, #7f776f)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22.5 24.11h30.991v1H22.5v-1Zm10.982 25.394v-1h-5.985v1h5.985Zm15.011-1h-6.012v1h6.012v-1Zm1.772-16.268v.003h-24.26v-.002H25.5v1h.505v.002h24.26v-.002h.226v-1h-.226Zm-6.499 11.726-.5.51-5.288-5.184-5.253 5.184-.5-.507 5.753-5.677 5.788 5.674Z",
        fill: "var(--dig-color__fileicon__icon-shadow, #736c64)"
      }
    )
  );
};
export {
  FilePackageLarge
};
